"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPackageJson = isPackageJson;
var _types = require("../types");
function isPackageJson(value) {
  return _types.packageJsonSchema.safeParse(value).success;
}
//# sourceMappingURL=isPackageJson.js.map